import mail from '../../../public/mail.png';
import femail from '../../../public/femail.png';
import { Bubble, Props as BubbleProps } from './Bubble';
import { ChoiceType } from '@raysee/schema';
import Image from 'next/image';

interface Props extends BubbleProps {
  choices?: string[];
  hideQuestionText?: boolean;
}

export const OptionsBubble = ({ message, choices, hideQuestionText, ...props }: Props) => {
  const options = choices || message.choices;

  return (
    <>
      {props.isWaiting ? (
        <Bubble {...props} message={message}>
          {!hideQuestionText && (
            <div
              className={`rounded-2xl border px-4 py-3 drop-shadow-sm ${
                props.sender ? 'bg-white' : 'bg-pink-100'
              }`}
            >
              <p>{message.text}</p>
            </div>
          )}
          <div className="mt-4 flex w-full flex-wrap justify-center gap-2">
            {options?.map((choice, i) => (
              <button
                key={i}
                className={`
            min-w-[120px] flex-1 rounded-md border border-[#EBEBED] px-3 py-2 font-bold
            ${getBackgroundColor(options, message.text, choice)}
          `}
                onClick={() => props.onSend(choice)}
                disabled={options?.includes(message.text)}
              >
                {((choice: string) => {
                  if ([ChoiceType.Male, ChoiceType.Female].includes(choice as ChoiceType)) {
                    return (
                      <div className="flex items-center justify-center">
                        <Icon
                          gender={choice as ChoiceType.Male | ChoiceType.Female}
                          active={!options?.includes(choice) || !(choice === message.text)}
                        />
                        <p className="ml-1 text-white">{choice}</p>
                      </div>
                    );
                  } else if ([ChoiceType.Yes, ChoiceType.No].includes(choice as ChoiceType)) {
                    const textColorStyle =
                      choice === ChoiceType.Yes ? 'text-white' : 'text-[#FF5CBE]';
                    return <p className={`ml-1 ${textColorStyle}`}>{choice}</p>;
                  } else {
                    return choice;
                  }
                })(choice)}
              </button>
            ))}
          </div>
        </Bubble>
      ) : (
        <Bubble {...props} message={message}>
          <div
            className={`rounded-2xl border px-4 py-3 drop-shadow-sm ${
              props.sender ? 'bg-white' : 'bg-pink-100'
            }`}
          >
            <p>{message.text}</p>
          </div>
        </Bubble>
      )}
    </>
  );
};

interface Color {
  waiting: string;
  active: string;
  inactive: string;
}

const getBackgroundColor = (options: string[], messageText: string, choice: string): string => {
  // ChoiceTypeの値の場合はenumとして扱う
  if (Object.values(ChoiceType).includes(choice as ChoiceType)) {
    return colors(choice as ChoiceType)[
      colorType(options.includes(messageText), choice === messageText)
    ];
  }
  // その他の選択肢の場合はデフォルトスタイルを返す
  return options.includes(messageText)
    ? 'bg-gray-300 text-gray-600'
    : 'bg-white text-gray-800 hover:bg-gray-50';
};

const colors = (choice: ChoiceType): Color =>
  ({
    [ChoiceType.Yes]: {
      waiting: 'bg-[#FF5CBE] text-white',
      active: 'bg-[#FBE2F2] ',
      inactive: 'bg-[#F2F2F2] text-white',
    },
    [ChoiceType.No]: {
      waiting: 'bg-white  border-[#FF5CBE]',
      active: 'bg-[#FBE2F2] ',
      inactive: 'bg-[#F2F2F2] text-white',
    },
    [ChoiceType.Male]: {
      waiting: 'bg-[#4DB3EB] text-white',
      active: 'bg-[#4DB3EB] text-white',
      inactive: 'bg-[#F2F2F2] text-white',
    },
    [ChoiceType.Female]: {
      waiting: 'bg-[#FA8887] text-white',
      active: 'bg-[#FA8887] text-white',
      inactive: 'bg-[#F2F2F2] text-white',
    },
  })[choice];

const colorType = (selected: boolean, active: boolean): keyof Color => {
  if (!selected) return 'waiting';
  else if (active) return 'active';
  else return 'inactive';
};

const Icon = (props: { gender: ChoiceType.Male | ChoiceType.Female; active: boolean }) => {
  switch (props.gender) {
    case ChoiceType.Male:
      return <Image src={mail} width={14} height={18} alt="アイコン" />;
    case ChoiceType.Female:
      return <Image src={femail} width={12} height={18} alt="アイコン" />;
  }
};
